import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

// Import Swiper styles if needed, but usually handled in main scss
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

export const init = () => {
    const blocks = document.querySelectorAll('.services');

    blocks.forEach(block => {
        const swiperContainer = block.querySelector('.services__swiper');
        if (!swiperContainer) return;

        const displayMode = block.getAttribute('data-display-mode') || 'grid';
        const isSliderMode = displayMode === 'slider';

        let swiperInstance = null;

        const initSwiper = () => {
            const isMobile = window.innerWidth < 768;
            const hasCta = block.classList.contains('services--has-cta');

            // Only initialize if it's slider mode OR we are on mobile
            if (isSliderMode || isMobile) {
                if (!swiperInstance) {
                    swiperInstance = new Swiper(swiperContainer, {
                        modules: [Navigation, Pagination, A11y],
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                        centeredSlides: isMobile,
                        loop: false,
                        a11y: {
                            enabled: true,
                            containerRole: 'region',
                            containerMessage: 'Servicios jurídicos',
                            containerRoleDescriptionMessage: 'carrusel',
                            prevSlideMessage: 'Servicio anterior',
                            nextSlideMessage: 'Servicio siguiente',
                            firstSlideMessage: 'Este es el primer servicio',
                            lastSlideMessage: 'Este es el último servicio',
                            paginationBulletMessage: 'Ir al servicio {{index}}',
                            slideLabelMessage: null,
                        },
                        navigation: {
                            nextEl: block.querySelector('.services__next'),
                            prevEl: block.querySelector('.services__prev'),
                        },
                        pagination: {
                            el: isMobile ? block.querySelector('.services__pagination-mobile') : block.querySelector('.services__pagination'),
                            type: isMobile ? 'bullets' : 'progressbar',
                            clickable: true,
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: (isSliderMode && hasCta) ? 2 : 3,
                                spaceBetween: 30,
                                centeredSlides: false,
                            }
                        }
                    });
                } else {
                    // Update swiper if already exists
                    swiperInstance.update();
                }
            } else {
                // If on desktop and grid mode, destroy swiper if exists
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                    swiperInstance = null;
                }
            }
        };

        initSwiper();

        // Re-check on resize
        window.addEventListener('resize', () => {
            initSwiper();
        });
    });
};
